import { render, staticRenderFns } from "./TopoTabela.vue?vue&type=template&id=30b1b032&scoped=true"
import script from "./TopoTabela.vue?vue&type=script&lang=js"
export * from "./TopoTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b1b032",
  null
  
)

export default component.exports